import styled from 'styled-components';
import { theme } from '../../../../../../../utils/theme';

export type RatingProps = {
  rating: number;
  maxRating?: number;
  className?: string;
};

const StarIcon = ({ filled }: { filled: boolean }) => (
  <svg
    width='20'
    height='19'
    viewBox='0 0 22 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z'
      fill={
        filled ? theme.landing.colors.primary : theme.landing.colors.lightBlue
      }
    />
  </svg>
);

const Rating = ({ rating, maxRating = 5, className }: RatingProps) => {
  const filledStars = Math.floor(rating);

  return (
    <RatingContainer
      className={className}
      role='img'
      aria-label={`${rating} de ${maxRating} estrellas`}
    >
      {Array.from({ length: maxRating }, (_, index) => (
        <StarIcon key={index} filled={index < filledStars} />
      ))}
    </RatingContainer>
  );
};

export default Rating;

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
